import { useMutation } from '@tanstack/react-query'
import { oauth2DashboardApi } from '../api/oauth2DashboardApi'
import type { OAuth2TestResponse } from '../types/oauth2Dashboard'
import { toast } from '@/integrations/toaster-provider'

export default function useTestOAuthConnectionMutation(onSuccess: () => void) {
  return useMutation<OAuth2TestResponse>({
    mutationFn: oauth2DashboardApi.testConnection,
    onSuccess: (data) => {
      if (data.success) {
        toast.success('OAuth2 connection test successful')
      } else {
        toast.error(
          `Connection test failed: ${data.connectionTest?.error || 'Unknown error'}`,
        )
      }
      onSuccess()
    },
    onError: (error: Error) => {
      toast.error(`Connection test failed: ${error.message || 'Unknown error'}`)
    },
  })
}
